import { notification, Avatar } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { reactive } from "vue";
import router from "../../../router";
import { createLoading } from "../../../utils/loading";
import { parseUrl, randomUuid } from "../../../utils/util";
import websocket from "../../../utils/websocket";

export const { isLoading, setIsLoading } = createLoading();

export const onClickNotification = (item) => {
    if (item.attribute?.url) {
        router.push(lodash.merge(item.attribute.url, { query: { _timestamp: new Date().getTime() } }));
    }
    if (!item.isRead) {
        item.isRead = true;
        state.notifications = lodash.cloneDeep(state.notifications);
        --state.unreadCount;
        websocket.send(`/app/notification/read/${item.id}`, {}, null);
    }
};

export const onScrollMenu = (e) => {
    const isBottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (isBottom && !isLoading.value && !state.end) {
        setIsLoading(true);
        ++state.page;
        websocket.send("/app/notification/get/me", {}, JSON.stringify({ page: state.page, size: state.size }));
    }
};

export const onWebsocketConnect = () => {
    state.websocketSubscribes.push(
        websocket.subscribe(`/user/topic/notification/new`, (res) => {
            const item = JSON.parse(res.body);
            ++state.unreadCount;
            state.notifications.push(item);
            let image = null;
            if (item.refFrom?.refImage?.url) {
                const src = parseUrl(item.refFrom.refImage.url);
                image = (
                    <div class="my-auto mr-2">
                        <Avatar size="large" src={src}></Avatar>
                    </div>
                );
            }
            const key = randomUuid();
            notification.open({
                key,
                class: "cursor-pointer",
                message: (
                    <div class="d-flex">
                        {image}
                        <div class="text-primary my-auto">
                            <span>{item.title}</span>
                        </div>
                    </div>
                ),
                description: (
                    <>
                        <div>
                            <small>{item.desc}</small>
                        </div>
                        <div class="text-right">
                            <small>
                                {item.refFrom?.fullName} ({moment(notification.createDate).format("DD/MM/YYYY HH:mm")})
                            </small>
                        </div>
                    </>
                ),
                onClick: () => {
                    onClickNotification(item);
                    notification.close(key);
                },
            });
        })
    );
    state.websocketSubscribes.push(
        websocket.subscribe(`/user/topic/notification/get/me`, (res) => {
            const currentItemIds = state.notifications.map((item) => item.id);
            let items = JSON.parse(res.body);
            items = items.filter((item) => !currentItemIds.includes(item.id));
            state.notifications.push(...items);
            if (items.length === 0) {
                state.end = true;
            }
            setTimeout(() => setIsLoading(false), 250);
        })
    );
    state.websocketSubscribes.push(
        websocket.subscribe(`/user/topic/notification/get/unread/me`, (res) => {
            state.unreadCount = res.body;
        })
    );

    websocket.send("/app/notification/get/unread/me", {}, null);
};

export const loadFirst = (visible) => {
    if (visible && !state.fisrt) {
        state.fisrt = true;
        websocket.send("/app/notification/get/me", {}, JSON.stringify({ page: state.page, size: state.size }));
    }
};

export const state = reactive({
    notifications: [],
    websocketId: null,
    websocketSubscribes: [],
    page: 0,
    size: 10,
    unreadCount: 0,
    fisrt: false,
    end: false,
});
